import classNames from 'classnames'
import { StaticImage } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'
import React from 'react'

import * as styles from './TwinFeatureSection.module.scss'
import ROUTES from '../../../constants/routes'
import Container from '../../container/Container'
import SwiperComponent from '../../swiper/Swiper'
import LinkWithIcon from '../../ui/buttons/link-with-icon/LinkWithIcon'

const features = [
  {
    name: 'Round-ups',
    title: 'Put your spare change to work',
    text: 'Use leftover change to access crypto micro-investments with round-ups.',
    picture: (
      <StaticImage
        src="../../../assets/images/Features_RoundUps.png"
        alt="Bamboo investments App"
        width={350}
        height={266}
      />
    ),
    linkPath: ROUTES.ROUND_UPS,
  },
  {
    name: 'Top-ups',
    title: 'Access the market on your terms',
    text: 'Choose when and how often you top up your investment portfolio.',
    picture: (
      <StaticImage
        src="../../../assets/images/Features_TopUp.png"
        alt="Bamboo investments App"
        width={350}
        height={266}
      />
    ),
    linkPath: ROUTES.TOP_UPS,
  },
  {
    name: 'Rebalance',
    title: 'Restructure your portfolio',
    text: 'Rebalance your portfolio mix across crypto and Gold and Silver Standard.',
    picture: (
      <StaticImage
        src="../../../assets/images/Features_Rebalance.png"
        alt="Bamboo investments App"
        width={350}
        height={266}
      />
    ),
    linkPath: ROUTES.REBALANCE,
  },
  {
    name: 'Portfolio',
    title: 'Hand pick your investment split',
    text: 'Customise a portfolio across Bitcoin, Ethereum, Gold and Silver Standard options.',
    picture: (
      <StaticImage
        src="../../../assets/images/Features_Portfolio.png"
        alt="Bamboo investments App"
        width={350}
        height={266}
      />
    ),
    linkPath: ROUTES.PORTFOLIO,
  },
  {
    name: 'Dollar Cost Averaging',
    title: 'Always be there when it counts',
    text: 'Easily enter the cryptocurrency market with regular investment contributions.',
    picture: (
      <StaticImage
        src="../../../assets/images/Features_DCA.png"
        alt="Bamboo investments App"
        width={350}
        height={266}
      />
    ),
    linkPath: ROUTES.DOLLAR_COST_AVERAGE,
  },
  {
    name: 'BAM Rewards',
    title: 'Earn rewards simply by using the Bamboo app',
    text: 'Earn BAM tokens every time you invest or refer a friend.',
    picture: (
      <StaticImage
        src="../../../assets/images/Features_BAM.png"
        alt="Bamboo investments App"
        width={350}
        height={266}
      />
    ),
    linkPath: ROUTES.BAM_REWARDS,
  },
  {
    name: 'SMSF',
    title: 'Invest in crypto with your Self-Managed Super Fund',
    text: 'To hear from one of our Crypto specialists about how you can sign up with your Self Managed Super Fund, let us know how to reach you.',
    picture: (
      <StaticImage
        src="../../../assets/images/Features_SMSF.png"
        alt="Bamboo investments App"
        width={350}
        height={266}
      />
    ),
    linkPath: ROUTES.SMSF,
  },
]

function TwinFeatureSection({ featuresList }) {
  const featuresCards = features
    ?.filter(({ name }) => featuresList?.includes(name))
    .sort((a, b) => featuresList.indexOf(a.name) - featuresList.indexOf(b.name))
    .map(({ name, title, text, picture, linkPath, className }, index) => (
      <div className={classNames(styles.featureItem, className)} key={name}>
        <div className={styles.imgWrapp}>{picture}</div>
        <h3 className={styles.featureTitle}>{title}</h3>
        <p className={styles.featureText}>{text}</p>
        {linkPath && (
          <LinkWithIcon className={styles.link} to={linkPath}>
            Visit page
          </LinkWithIcon>
        )}
      </div>
    ))

  return (
    <section className={styles.section}>
      <Container>
        <h2 className={styles.title}>
          More features to keep effortless{'\n'}investing in your hands.
        </h2>
        <div className={styles.features}>{featuresCards}</div>
        <div className={styles.swiperContent}>
          <SwiperComponent
            centeredSlides
            spaceBetween={32}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 2,
              },
            }}
          >
            {featuresCards}
          </SwiperComponent>
        </div>
      </Container>
    </section>
  )
}

TwinFeatureSection.propTypes = {
  featuresList: PropTypes.arrayOf(PropTypes.string),
}

export default TwinFeatureSection
